import { cva } from '@vizit/theme';

const tableClasses = cva({
  base: [
    // Fixed layout sizes columns from the header only, so swapping skeleton rows for loaded rows (or
    // virtualizing different rows in) can't re-flow the columns.
    'w-full table-fixed bg-white',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2',
  ],
  variants: {
    // The fixed columns in ProductListingTableThead with the action column shown (544px, 664px with Retailer)
    // plus 320px for the product column. Below this the container scrolls horizontally instead of crushing the
    // product column.
    withRetailer: {
      false: 'min-w-[864px]',
      true: 'min-w-[984px]',
    },
  },
  defaultVariants: {
    withRetailer: false,
  },
});

const tableContainerClasses = cva({
  // Stable gutter: with always-visible scrollbars, the loaded table's vertical scrollbar would otherwise narrow the
  // table (and shift every column) compared with the skeleton, which never overflows.
  base: ['border border-primary overflow-auto [scrollbar-gutter:stable]'],
});

const productCountClasses = cva({
  base: 'h-10 w-36 my-5',
});

const productTableWrapperClasses = cva({
  base: 'flex flex-col gap-6 w-full',
});

export { productCountClasses, productTableWrapperClasses, tableClasses, tableContainerClasses };
